'use strict';

export var LOAD = 'REDUX_STORAGE_LOAD';
export var SAVE = 'REDUX_STORAGE_SAVE';